// Field-update dispatch thunks extracted from Services/ServicesThunks.js

import _ from "lodash";

import { updateUnitPlan } from "IBPlanner/modules/IBPlannerModule";
import { updateLe } from "LearningEngagement/modules/LeModule";
import { updateAssessment } from "Assessments/modules/AssessmentModule";
import { updateChecklistElement } from "Checklist/modules/ChecklistModule";
import { updateRubricElement } from "Rubric/modules/RubricModule";
import { updateSinglePointRubricElement } from "SinglePointRubric/modules/SinglePointRubricModule";
import {
  updateRemark,
  handleAssessmentToolResponse,
  createIbPypElementRatingV2,
} from "AssessmentEvaluation/modules/AssessmentEvaluationModule";
import { updateSubjectMutationFn } from "SubjectsSetup/modules/SubjectsModule";
import {
  editStudentAssignmentSubmission,
  updateElementRemark,
} from "ClassRoom/modules/ClassRoomModule";
import { updateAssessmentToolElement } from "modules/AssessmentTool/AssessmentToolModule";
import {
  updateProjectField,
  updateStudentProjectPortfolioField,
} from "Projects/modules/ProjectModules";
import { createIBPYPElementRatings } from "ClassProgressSummaryV2/modules/ClassProgressSummaryModule";

// Module-level dispatch-debounce map. Keyed by `${type}:${key}`; entries are
// drained by updateFieldMutationFunc.
const fields = {};

// Thunk Helpers
const dispatchUpdateFieldMutationFunc = dispatchFunc => {
  dispatchFunc(updateFieldMutationFunc());
};

const debouncedDispatchUpdateFieldMutation = _.debounce(
  dispatchUpdateFieldMutationFunc,
  1000
);

// Force any pending debounced updateField call to fire immediately. No-op if
// nothing is pending. Lets callers (e.g. evaluation actions) drain in-flight
// edits before depending on their state.
export const flushPendingFieldUpdates = () => {
  debouncedDispatchUpdateFieldMutation.flush();
};

export const updateFieldMutationFunc = () => {
  return (dispatch, getState) => {
    _.map(fields, (obj, key) => {
      if (obj.func) {
        obj.func(obj.params);
      } else {
        switch (obj.type) {
          case "LEARNING_ENGAGEMENT":
            dispatch(updateLe(obj.params));
            break;
          case "ASSESSMENT":
            dispatch(updateAssessment(obj.params));
            break;
          case "UNIT_PLAN":
            dispatch(updateUnitPlan(obj.params));
            break;

          case "ASSESSMENT_TOOL_ELEMENT":
            dispatch(updateAssessmentToolElement(obj.params));
            break;
          case "RUBRIC_ELEMENT":
            dispatch(updateRubricElement(obj.params));
            break;
          case "SINGLE_POINT_RUBRIC_ELEMENT":
            dispatch(updateSinglePointRubricElement(obj.params));
            break;
          case "CHECKLIST_ELEMENT":
            dispatch(updateChecklistElement(obj.params));
            break;

          case "EVALUATION_REMARK":
            dispatch(updateRemark(obj.params));
            break;

          case "EVALUATION_TOOL":
            dispatch(handleAssessmentToolResponse(obj.params));
            break;
          case "SUBJECT_GROUPS_SUBJECTS":
          case "SUBJECTS_SETUP":
            dispatch(updateSubjectMutationFn({ input: obj.params, t: obj.t }));
            break;
          case "STUDENT_ASSIGNMENT_SUBMISSION":
            dispatch(
              editStudentAssignmentSubmission({ mutationParams: obj.params })
            );
            break;
          case "PROJECT":
            dispatch(updateProjectField(obj.params));
            break;
          case "STUDENT_PROJECT_PORTFOLIO":
            dispatch(updateStudentProjectPortfolioField(obj.params));
            break;
          case "ELEMENT_REMARK":
            dispatch(updateElementRemark(obj.params));
            break;
          case "CREATE_ELEMENT_RATINGS":
            dispatch(createIBPYPElementRatings({ ...(obj.params || {}) }));
            break;
          case "CREATE_ELEMENT_RATINGS_V2":
            dispatch(createIbPypElementRatingV2({ ...(obj.params || {}) }));
            break;
        }
      }

      delete fields[key];
    });
  };
};

export const updateField = ({
  key,
  type,
  params,
  isDebounce = true,
  func,
  t,
}) => {
  return (dispatch, getState) => {
    fields[`${type}:${key}`] = { type, params, func, t };
    if (isDebounce) {
      debouncedDispatchUpdateFieldMutation(dispatch);
    } else {
      dispatch(updateFieldMutationFunc());
    }
  };
};
